import React from 'react';
import axios from 'axios';
import useAsyncEffect from 'use-async-effect/';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import CssBaseline from '@mui/material/CssBaseline';
import { Amplify } from 'aws-amplify';

import { env } from './env';
import NotificationProvider from './providers/NotificationProvider';
import { MytaverseProvider } from './providers/MytaverseProvider';
import { NavigationHistoryProvider } from './providers/NavigationHistoryProvider';
import Routes from './routes/Routes';
import i18next from './locales/i18n';
import PolicyModal from './ek/modules/auth/components/PolicyModal';
import LogoutNotificationModal from './ek/modules/components/LogoutNotificationModal';

import './styles/App.scss';
import './ek/styles/App.scss';

const {
  REACT_APP_COGNITO_CLIENT_ID,
  REACT_APP_COGNITO_USERPOOL_ID,
  REACT_APP_COGNITO_DOMAIN,
  REACT_APP_HUB_VERSION,
  REACT_APP_API_URL
} = env;

console.log(`Hub version v${REACT_APP_HUB_VERSION}`);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: REACT_APP_COGNITO_CLIENT_ID,
      userPoolId: REACT_APP_COGNITO_USERPOOL_ID,
      loginWith: {
        oauth: {
          domain: REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid'],
          // scopes: Object.values(ParticipantScopes),
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code',
        },
      },
    },
  },
});

declare module 'axios' {
  export interface AxiosRequestConfig {
    sendAuth0Headers?: boolean;
  }
}

const App = () => {
  useAsyncEffect(async () => {
    const {
      data: { version },
    } = await axios.get(`${REACT_APP_API_URL}api/version`);

    console.log(`API version: v${version}`);
  }, []);

  return (
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>
        <CssBaseline />
        <NavigationHistoryProvider>
          <NotificationProvider>
            <MytaverseProvider>
              <Routes />
              <PolicyModal />
              <LogoutNotificationModal />
            </MytaverseProvider>
          </NotificationProvider>
        </NavigationHistoryProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
};

export default App;
